import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";
import { useToast } from "vue-toastification";
import { UpdateMarcaVehiculoAction } from "../../actions/marcaVehiculosActions";
import { MarcaVehiculoUpdateParams } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculoUpdateParams";

const toast = useToast();

export function useMarcaVehiculoUpdate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ idMarca, formData }: MarcaVehiculoUpdateParams) =>
      UpdateMarcaVehiculoAction(idMarca, formData),

    onSuccess: async (
      response: ApiResponse<MarcaVehiculoInterface>,
      variables
    ) => {
      queryClient.removeQueries({
        queryKey: ["MarcaVehiculoFindOne", variables.idMarca],
      });
      await queryClient.refetchQueries({
        queryKey: ["MarcaVehiculosList"],
        exact: true,
      });
      await queryClient.refetchQueries({
        queryKey: ["MarcaModeloList"],
        exact: true,
      });
      toast.success("Marca de vehÃ­culo actualizada correctamente");

      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al actualizar marca de vehÃ­culo");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, isSuccess, data }
  };
}
